import { Builder } from '@builder.io/react'
import React from 'react'

import { HeadingClass, HeadingType } from 'enums'
import LinkButton, { LinkButtonProp, LinkButtonRegisterProps } from '../common/button'
import CustomHeading, { headingTypePropObj, headingClassPropObj } from '../common/heading'

enum ImageSide {
  Left = 'left',
  Right = 'right'
}

interface Props {
  backgroundColor: string
  boxBackgroundColor: string
  headingText: string
  headingTextColor: string
  subText: string
  subTextColor: string
  imageSrc: any
  imgAltText: string
  buttonOne: LinkButtonProp
  imageSide: ImageSide
  headingType: HeadingType
  headingClass: HeadingClass
  textureColor: string
  button: boolean
  imageFill: 'cover' | 'contain'
}

const CTAOne = ({
  backgroundColor,
  headingText,
  headingTextColor,
  subText,
  subTextColor,
  imageSrc,
  imgAltText = '',
  buttonOne,
  imageSide,
  boxBackgroundColor,
  headingType,
  headingClass,
  textureColor,
  button,
  imageFill
}: Props) => {
  const getContent = () => {
    if (imageSide === ImageSide.Left) {
      return (
        <>
          <div className="relative z-10 lg:col-span-4 lg:col-start-1 lg:row-start-1 lg:bg-transparent lg:py-16">
            <div
              className="absolute inset-x-0 bottom-0 h-1/2 bg-gray-50 lg:hidden"
              aria-hidden="true"
              style={{ backgroundColor: boxBackgroundColor }}
            />
            <div className="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 sm:py-4 lg:max-w-none lg:p-0">
              <div className="aspect-w-1 aspect-h-1">
                <img
                  className="left-1/2 -translate-x-1/2 object-top"
                  style={{ maxWidth: '500px', maxHeight: '500px', objectFit: imageFill }}
                  src={
                    imageSrc ||
                    'https://images.unsplash.com/photo-1507207611509-ec012433ff52?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=934&q=80'
                  }
                  alt={imgAltText}
                />
              </div>
            </div>
          </div>
          <div
            className="relative lg:col-span-10 lg:col-start-3 lg:row-start-1 lg:grid lg:grid-cols-10 lg:items-center"
            style={{ backgroundColor: boxBackgroundColor }}
          >
            <div className="absolute inset-0 hidden overflow-hidden  lg:block" aria-hidden="true">
              <svg
                className="absolute bottom-full left-full translate-y-1/3 -translate-x-2/3 transform xl:bottom-auto xl:top-0 xl:translate-y-0"
                width={404}
                height={384}
                fill="none"
                viewBox="0 0 404 384"
                aria-hidden="true"
              >
                <defs>
                  <pattern
                    id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                    x={0}
                    y={0}
                    width={20}
                    height={20}
                    patternUnits="userSpaceOnUse"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={4}
                      height={4}
                      className="text-indigo-500"
                      fill="currentColor"
                      style={{ color: textureColor }}
                    />
                  </pattern>
                </defs>
                <rect width={404} height={384} fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)" />
              </svg>
              <svg
                className="absolute top-full -translate-y-1/3 -translate-x-1/3 transform xl:-translate-y-1/2"
                width={404}
                height={384}
                fill="none"
                viewBox="0 0 404 384"
                aria-hidden="true"
              >
                <defs>
                  <pattern
                    id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                    x={0}
                    y={0}
                    width={20}
                    height={20}
                    patternUnits="userSpaceOnUse"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={4}
                      height={4}
                      className="text-indigo-500"
                      fill="currentColor"
                      style={{ color: textureColor }}
                    />
                  </pattern>
                </defs>
                <rect width={404} height={384} fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)" />
              </svg>
            </div>
            <div className="relative mx-auto max-w-md space-y-6 py-12 px-4 sm:max-w-3xl sm:py-16 sm:px-6 lg:col-span-6 lg:col-start-4 lg:max-w-none lg:p-0">
              <CustomHeading
                classList="font-bold text-white"
                headingClass={headingClass}
                headingType={headingType}
                color={headingTextColor}
              >
                {headingText}
              </CustomHeading>
              <p className="text-lg text-white" style={{ color: subTextColor }}>
                {subText}
              </p>
              {button && buttonOne && (
                <LinkButton
                  buttonColor={buttonOne.buttonColor}
                  buttonText={buttonOne.buttonText}
                  buttonTextColor={buttonOne.buttonTextColor}
                  loggedInButtonText={buttonOne.loggedInButtonText}
                  buttonUrl={buttonOne.buttonUrl}
                  isLink={buttonOne.isLink}
                  classList={
                    'block w-full py-3 px-5 text-center bg-white border border-transparent rounded-full shadow-md text-base font-medium text-indigo-700 hover:bg-gray-50 sm:inline-block sm:w-auto'
                  }
                />
              )}
            </div>
          </div>
        </>
      )
    }

    return (
      <>
        <div
          className="relative lg:col-span-10 lg:col-start-1 lg:row-start-1 lg:grid lg:grid-cols-10 lg:items-center "
          style={{ backgroundColor: boxBackgroundColor }}
        >
          <div className="absolute inset-0 hidden overflow-hidden lg:block" aria-hidden="true">
            <svg
              className="absolute bottom-full left-full translate-y-1/3 -translate-x-2/3 transform xl:bottom-auto xl:top-0 xl:translate-y-0"
              width={404}
              height={384}
              fill="none"
              viewBox="0 0 404 384"
              aria-hidden="true"
            >
              <defs>
                <pattern
                  id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-indigo-500"
                    fill="currentColor"
                    style={{ color: textureColor }}
                  />
                </pattern>
              </defs>
              <rect width={404} height={384} fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)" />
            </svg>
            <svg
              className="absolute top-full -translate-y-1/3 -translate-x-1/3 transform xl:-translate-y-1/2"
              width={404}
              height={384}
              fill="none"
              viewBox="0 0 404 384"
              aria-hidden="true"
            >
              <defs>
                <pattern
                  id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-indigo-500"
                    fill="currentColor"
                    style={{ color: textureColor }}
                  />
                </pattern>
              </defs>
              <rect width={404} height={384} fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)" />
            </svg>
          </div>
          <div className="relative mx-auto max-w-md space-y-6 py-12 px-4 sm:max-w-3xl sm:py-16 sm:px-6 lg:col-span-6 lg:col-start-2 lg:max-w-none lg:p-0">
            <CustomHeading
              classList="font-bold text-white"
              headingClass={headingClass}
              headingType={headingType}
              color={headingTextColor}
            >
              {headingText}
            </CustomHeading>

            <p className="text-lg text-white" style={{ color: subTextColor }}>
              {subText}
            </p>
            {button && buttonOne && (
              <LinkButton
                buttonColor={buttonOne.buttonColor}
                buttonText={buttonOne.buttonText}
                buttonTextColor={buttonOne.buttonTextColor}
                loggedInButtonText={buttonOne.loggedInButtonText}
                buttonUrl={buttonOne.buttonUrl}
                isLink={buttonOne.isLink}
                classList={
                  'block w-full py-3 px-5 text-center bg-white border border-transparent rounded-full shadow-md text-base font-medium text-indigo-700 hover:bg-gray-50 sm:inline-block sm:w-auto'
                }
              />
            )}
          </div>
        </div>
        <div className="relative z-10 lg:col-span-4 lg:col-start-9 lg:row-start-1 lg:bg-transparent lg:py-16">
          <div
            className="absolute inset-x-0 top-0 h-1/2 bg-gray-50 lg:hidden"
            aria-hidden="true"
            style={{ backgroundColor: boxBackgroundColor }}
          />
          <div className="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:max-w-none lg:p-0">
            <div className="aspect-w-1 aspect-h-1">
              <img
                className=" left-1/2 -translate-x-1/2 object-top"
                style={{ maxWidth: '500px', maxHeight: '500px', objectFit: imageFill }}
                src={
                  imageSrc ||
                  'https://images.unsplash.com/photo-1507207611509-ec012433ff52?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=934&q=80'
                }
                alt={imgAltText}
              />
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <div className="relative bg-white py-16" style={{ backgroundColor: backgroundColor }}>
      <div
        className="absolute inset-x-0 top-0 hidden h-1/2 bg-gray-50 lg:block"
        aria-hidden="true"
        style={{ backgroundColor: backgroundColor }}
      />
      <div className="mx-auto max-w-7xl lg:bg-transparent lg:px-8">
        <div className="lg:grid lg:grid-cols-12">{getContent()}</div>
      </div>
    </div>
  )
}

export default CTAOne

Builder.registerComponent(CTAOne, {
  name: 'CTAOne',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'lightgreen'
    },
    {
      name: 'textureColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'boxBackgroundColor',
      type: 'color',
      defaultValue: 'blue'
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: 'Join our team'
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'subText',
      type: 'text',
      defaultValue:
        'Varius facilisi mauris sed sit. Non sed et duis dui leo, vulputate id malesuada non. Cras aliquet purus dui laoreet diam sed lacus, fames.'
    },
    {
      name: 'subTextColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'imageSrc',
      type: 'file',
      defaultValue: null
    },
    {
      name: 'imgAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonOne'
    },
    {
      name: 'imageSide',
      type: 'string',
      enum: ['left', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'button',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'imageFill',
      type: 'text',
      enum: ['cover', 'contain'],
      defaultValue: 'cover'
    }
  ]
})
